@if (form && definition) {
  <div
    class="flex flex-col"
    >
    <label class="soft-label soft-label-top">
      {{ definition.title }}
      @if (definition.required | booleanRule: form.value) {
        <span
          class="required-indicator"
          >*</span
          >
        }
      </label>
      <soft-duration-input
        [formControl]="form|formControl:definition.name"
        [format]="definition.format | formatRule: form.value"
        softFieldValidation
      ></soft-duration-input>
    </div>
  }
